module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('h1', {
    staticClass: "plm_hd"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PROV_contents"
    }
  }, [_vm._v("﻿Select bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Anderson, B. W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Living World of the Old Testament")]), _vm._v(" (Longmans, 2nd edition 1967).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Anderson, G. W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Critical Introduction to the Old Testament")]), _vm._v(" (Duckworth, 1959).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Clements, R. E., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wisdom in Theology")]), _vm._v(" (Paternoster, 1992).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Coughenour, R. A., ‘The Wisdom Literature of the Bible’, and other unpublished documents, kindly made available to me by the author.")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Goldingay, J., ‘Proverbs’, in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New Bible Commentary")]), _vm._v(" (IVP, 1995 edition).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Groome, T. H., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Christian Religious Education")]), _vm._v(" (Harper and Row, 1981).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Henry, Matthew, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Exposition of the Old and New Testaments")]), _vm._v(" (1708–10, various editions).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Horton, R. F., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Book of Proverbs")]), _vm._v(", The Expositor’s Bible (Hodder and Stoughton, 1911).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Hubbard, D. A., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Proverbs")]), _vm._v(", The Communicator’s Commentary (Word, 1989).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Kidner, Derek, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Proverbs")]), _vm._v(", Tyndale Old Testament Commentaries (IVP, 1964).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("__ "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Wisdom of Proverbs, Job and Ecclesiastes")]), _vm._v(" (IVP, 1985).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("McKane, W., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Proverbs: A New Approach")]), _vm._v(", Old Testament Library (SCM, 1975).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Perry, T. A., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wisdom Literature and the Structure of Proverbs")]), _vm._v(" (Pennsylvania State University Press, 1993).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Scott, R. B. Y., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Proverbs; Ecclesiastes")]), _vm._v(", Anchor Bible (Doubleday, 1965).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Toy, C. H., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Book of Proverbs")]), _vm._v(", International Critical Commentary (T. and T. Clark, 1899).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("Whybray, R. N., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Proverbs")]), _vm._v(", New Century Bible Commentary (Marshall Pickering, 1994).")]), _vm._v(" "), _c('p', {
    staticClass: "biblio1"
  }, [_vm._v("__ "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wisdom in Proverbs")]), _vm._v(", Studies in Biblical Theology 45 (SCM, 1965).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3513d48c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/PROV_bibliog.vue
// module id = 75
// module chunks = 0